import moment from 'moment';

import datos from './mock/facturas.json';
import catalogo from './mock/itemsCompra.json';
import factura1 from './mock/pdfs/factura1.pdf';
import factura2 from './mock/pdfs/factura2.pdf';
import factura3 from './mock/pdfs/factura3.pdf';
import factura4 from './mock/pdfs/factura4.pdf';
import factura5 from './mock/pdfs/factura5.pdf';
import factura6 from './mock/pdfs/factura6.pdf';
import factura7 from './mock/pdfs/factura7.pdf';
import { formatNumber } from '../../assets/shared/formatNumber';

/**
 * Datos de la demo de SmartScan (todo ficticio, sin backend). Las facturas tienen la forma de lo que devuelve
 * /api/documents de SmartScan: cabecera, líneas, impuestos y percepciones, cada una con su ítem de compra de Eiffel.
 */

const urlsPdf = { factura1, factura2, factura3, factura4, factura5, factura6, factura7 };

export const facturasIniciales = datos.facturas;
export const facturasPorSubir = datos.porSubir;
export const itemsCompra = catalogo;

export const pdfFactura = (factura) => ({ url: urlsPdf[factura.pdf], nombreArchivo: factura.archivo });

export const descripcionItem = (codigo) => {
  const item = catalogo.find((i) => i.codigo === codigo);
  return item ? item.descripcion : '';
};

export const formatImporte = (valor) => `$ ${formatNumber(valor || 0)}`;
export const formatFecha = (fecha) => (fecha ? moment(fecha).format('DD/MM/YYYY') : '—');

/** Grupos de líneas que se imputan a un ítem de compra, en el orden en que se muestran. */
export const gruposLineas = [
  { clave: 'items', titulo: 'Líneas de la factura', texto: (l) => l.detalle, detalle: (l) => `cant. ${formatNumber(l.cantidad)} · ${formatImporte(l.total)}`, importe: (l) => l.total },
  { clave: 'impuestos', titulo: 'Impuestos', texto: (l) => `${l.impuesto} ${formatNumber(l.alicuota)}%`, detalle: (l) => formatImporte(l.importe), importe: (l) => l.importe },
  { clave: 'percepciones', titulo: 'Percepciones', texto: (l) => `${l.percepcion} ${l.jurisdiccion} ${formatNumber(l.alicuota)}%`, detalle: (l) => formatImporte(l.importe), importe: (l) => l.importe }
];

/** Datos de cabecera que no pueden faltar para grabar en Eiffel. */
const camposObligatorios = [
  { campo: 'cuit', mensaje: 'Falta el CUIT del proveedor' },
  { campo: 'numero', mensaje: 'Falta el número del comprobante' },
  { campo: 'fecha', mensaje: 'Falta la fecha del comprobante' },
  { campo: 'total', mensaje: 'Falta el importe total' }
];

export const camposFaltantes = (factura) => camposObligatorios.filter(({ campo }) => !factura[campo]).map(({ campo }) => campo);

export const lineasSinAsignar = (factura) =>
  gruposLineas.reduce((cantidad, grupo) => cantidad + factura[grupo.clave].filter((linea) => !linea.itemCompra).length, 0);

/** Lo que falta para poder aprobar (mismos textos que validate_for_eiffel de SmartScan). */
export const problemasFactura = (factura) => [
  ...camposObligatorios.filter(({ campo }) => !factura[campo]).map(({ mensaje }) => mensaje),
  ...gruposLineas.flatMap((grupo) =>
    factura[grupo.clave].filter((linea) => !linea.itemCompra).map((linea) => `'${grupo.texto(linea)}' no tiene ítem de compra asignado`)
  )
];

export const estadosFactura = {
  faltanDatos: { clave: 'faltanDatos', nombre: 'Faltan datos', color: '#f5c518', textColor: '#000000' },
  pendiente: { clave: 'pendiente', nombre: 'Pendiente', color: '#fb8c00', textColor: '#ffffff' },
  lista: { clave: 'lista', nombre: 'Lista para aprobar', color: '#00bcd4', textColor: '#ffffff' },
  aprobada: { clave: 'aprobada', nombre: 'Aprobada', color: '#2e7d32', textColor: '#ffffff' }
};

export const estadosEiffel = {
  pendiente: { nombre: 'En cola para Eiffel', color: '#e0f7fa', textColor: '#0097a7' },
  grabado: { nombre: 'Grabada en Eiffel', color: '#e8f5e9', textColor: '#2e7d32' },
  error: { nombre: 'Error al grabar', color: '#ffebee', textColor: '#d32f2f' }
};

export const estadoFactura = (factura) => {
  if (factura.estado === 'aprobada') return estadosFactura.aprobada;
  if (camposFaltantes(factura).length > 0) return estadosFactura.faltanDatos;
  if (lineasSinAsignar(factura) > 0) return estadosFactura.pendiente;
  return estadosFactura.lista;
};

/** Nombre del estado para mostrar: "2 pendientes" en lugar de "Pendiente". */
export const nombreEstado = (factura) => {
  const estado = estadoFactura(factura);
  if (estado !== estadosFactura.pendiente) return estado.nombre;
  const cantidad = lineasSinAsignar(factura);
  return `${cantidad} pendiente${cantidad === 1 ? '' : 's'}`;
};

export const esPendiente = (factura) => factura.estado !== 'aprobada';
